import React from "react";

const Heading = ({ children }) => {
  return (
    <h1 className="mb-4 w-full text-center text-xl font-semibold tracking-normal text-slate-800 sm:text-2xl">
      {children}
    </h1>
  );
};


export default Heading;
